const deepOmit = ({ payload, keysToOmit }) => {
  const omitTypename = (key, value) => (keysToOmit.includes(key) ? undefined : value)
  return JSON.parse(JSON.stringify(payload), omitTypename)
}

export { deepOmit }
